import React, {Component} from 'react'
import store from 'store'
import { PROTOCOL } from '@/utils/messageProtocol'
import { isQuickBIReportUrl, fetchQuickBIReportUrl } from '@/utils/util'

// styl
import './IndexIframe.styl'

/**
 * QuickBI 报表 URL 刷新间隔（3.5 小时，略小于 4 小时有效期）
 */
const REPORT_REFRESH_INTERVAL = 3.5 * 60 * 60 * 1000

class IndexIframe extends Component{
  state = {
    iframeList: []
  }

  /**
   * 存储各 iframe 的自动刷新定时器，key 为模块 id
   */
  _refreshTimers = {}

  componentDidMount() {
    // 1、第一次点击模块
    this.props.openModule.map(item => {
      this.setIframeElement(item)
    })
    // 监听子应用 access_token 请求（消息回投）
    window.addEventListener('message', this.handleTokenRequest)
  }

  componentWillUnmount() {
    // 清除所有刷新定时器，防止内存泄漏
    Object.keys(this._refreshTimers).forEach(id => {
      this.clearRefreshTimer(id)
    })
    // 移除子应用 access_token 请求监听
    window.removeEventListener('message', this.handleTokenRequest)
  }

  /**
   * 状态更新时调用
   */
  componentDidUpdate(prevProps, prevState) {
    this.updateIframe()
  }

  /**
   * 第一次之后点击模块、标签触发
   */
  updateIframe() {
    // 1、获取已存在iframe id
    const iframeIdList = []
    this.indexIframe.querySelectorAll('.inner-iframe').forEach(item => {
      const moduleId = item.getAttribute('data-id')
      item.setAttribute('style', moduleId === `${this.props.openModuleId}` ? 'display:block' : 'display:none')
      iframeIdList.push(moduleId)
    })

    // 2、当前模块没有被打开
    if (Number(this.props.openModuleId) !== -1 && !iframeIdList.some(item => item === `${this.props.openModuleId}`)) {
      this.setIframeElement([...this.props.openModule].pop())
    }

    // 3、删除已关闭的iframe
    if (this.props.removeModuleId !== -1 && this.props.opera === 'remove') {
      const removeId = `${this.props.removeModuleId}`
      this.clearRefreshTimer(removeId)
      if (document.querySelector(`#iframe-${removeId}`)) {
        document.querySelector(`#iframe-${removeId}`).remove()
      }
      this.props.resetRemoveModuleId()
    }
  }

  /**
   * 判断 URL 是否为需要自动刷新的 QuickBI 报表地址
   */
  isReportUrl(path) {
    return isQuickBIReportUrl(path)
  }

  /**
   * 报表换票加载：请求 isRedirect=false 换取 accessTicket 地址后设置 iframe src
   */
  loadReport(iframeId, reportPath) {
    fetchQuickBIReportUrl(reportPath)
      .then((url) => {
        // 换票返回前 iframe 可能已被关闭
        const iframe = document.getElementById(`iframe-${iframeId}`)
        if (!iframe) return
        iframe.src = url
      })
      .catch(() => {
        // 换票失败时 iframe 保持空白
      })
  }

  /**
   * 调度下一次自动刷新：到期后重新换票获取新的 accessTicket 地址并更新 iframe src
   */
  scheduleRefresh(iframeId, reportPath) {
    this._refreshTimers[iframeId] = setTimeout(() => {
      const iframe = document.getElementById(`iframe-${iframeId}`)
      if (!iframe) {
        this.clearRefreshTimer(iframeId)
        return
      }
      // 报表改走换票接口，不再依赖 URL 拼接 access_token
      this.loadReport(iframeId, reportPath)
      // 递归调度下一次刷新
      this.scheduleRefresh(iframeId, reportPath)
    }, REPORT_REFRESH_INTERVAL)
  }

  /**
   * 清除指定 iframe 的自动刷新定时器
   */
  clearRefreshTimer(iframeId) {
    if (this._refreshTimers[iframeId]) {
      clearTimeout(this._refreshTimers[iframeId])
      delete this._refreshTimers[iframeId]
    }
  }

  /**
   * 处理子应用 access_token 请求：逐一比对本组件创建的所有 iframe，
   * token 实时取自登录态，只回投给消息真实来源 origin
   */
  handleTokenRequest = (event) => {
    const { data, origin, source } = event
    // ① 协议过滤
    if (!data || data.type !== PROTOCOL.REQ || !source || !this.indexIframe) return
    console.log('[iframe-token] IndexIframe 收到子应用 token 请求:', origin)
    // ② 多 iframe 逐一比对，只认自家 iframe 子窗
    const isOwnIframe = Array.from(
      this.indexIframe.querySelectorAll('.inner-iframe')
    ).some(iframe => iframe.contentWindow === source)
    if (!isOwnIframe) return
    // ③④ 回投实时 token，只发给消息真实来源，绝不用 "*"
    const token = store.get('token') || ''
    console.log('[iframe-token] IndexIframe 回投 token:', origin, token ? `${token.slice(0, 8)}...(len=${token.length})` : '(空)')
    source.postMessage(
      { type: PROTOCOL.RES, access_token: token },
      origin
    )
  }

  /**
   * 生成iframe元素
   */
  setIframeElement({id, path, backPath}) {
    const iframeId = `${id}`
    const iframe = document.createElement('iframe')
    iframe.setAttribute('id', `iframe-${iframeId}`)
    iframe.setAttribute('data-id', iframeId)
    iframe.setAttribute('class', 'inner-iframe')
    iframe.setAttribute('style', 'display:block')
    // 报表判断以 path 为准并兼容 backPath：pathFirstRouter 自动打开的模块不带 backPath
    const isReport = this.isReportUrl(path) || this.isReportUrl(backPath)
    // 报表地址先置空，换票成功后再设置真实 src
    iframe.setAttribute('src', isReport ? 'about:blank' : path)
    iframe.setAttribute('allowfullscreen', true)

    this.indexIframe.appendChild(iframe)

    // 报表类 URL 换票加载并启动自动刷新定时器
    if (isReport) {
      this.loadReport(iframeId, path)
      this.scheduleRefresh(iframeId, path)
    }
  }

  render() {
    return <div className={`${this.props.isTenant ? 'index-iframe-tenant' : 'index-iframe'}`} id='indexIframe' ref={indexIframe => this.indexIframe = indexIframe} />
  }
}

export default IndexIframe
